import ProductsGrid from '~/src/common/components/ProductsGrid';
import I18n from '~/src/common/services/I18n';
import { useSearchRelatedArticles } from '~/src/queries/api-ecom/generated/api-ecom';

import * as S from './layout';

interface Props {
  excludeIds?: string[];
  text: string;
}

const AdditionalProductsPanel = ({ excludeIds = [], text }: Props) => {
  const { data, refetch } = useSearchRelatedArticles({ excludeIds, text, limit: 24 });

  return data?.items.length ? (
    <div>
      <S.AdditionalProductsTitle>
        {I18n.t('search-products-screen.additional-products.title')}
      </S.AdditionalProductsTitle>
      <ProductsGrid products={data.items} eventSource="search cross sell" onRefresh={refetch} />
    </div>
  ) : null;
};

export default AdditionalProductsPanel;
